import { ClerkProvider, useAuth } from '@clerk/clerk-react';
import { shadcn } from '@clerk/themes';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import { ConvexReactClient } from 'convex/react';
import { ConvexProviderWithClerk } from 'convex/react-clerk';

import { ThemeProvider } from './components/ThemeProvider';
import { Toaster } from './components/ui/sonner';
import { routeTree } from './routeTree.gen';

const router = createRouter({ routeTree });
const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);
const clerkPublishableKey = import.meta.env
  .VITE_CLERK_PUBLISHABLE_KEY as string;

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <ClerkProvider
        publishableKey={clerkPublishableKey}
        appearance={{
          baseTheme: shadcn,
        }}
      >
        <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
          <RouterProvider router={router} />
          <Toaster />
        </ConvexProviderWithClerk>
      </ClerkProvider>
    </ThemeProvider>
  );
}

export default App;
